export default {
      id: "Map-usage",
      viewBox: "0 0 520 666",
      url: "../dist/images/" + "sprite.svg#Map-usage",
      toString: function () {
        return this.url;
      }
    }